import React, { useState, useEffect, useCallback, useRef } from 'react';
import './../../App.css';
import './../Personnel/Employees.css';
import {CreateSearchBarWithPlaceHolder, CreateButton} from '../CommonObjects';
import {CreateTableForEmployeeSelect} from '../ManageTable';
import {SetAuditTrail, SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import {useTable, useSortBy} from 'react-table';
import jsPDF from "jspdf";
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import DoneIcon from '@mui/icons-material/Done';
import ChecklistIcon from '@mui/icons-material/Checklist';
import ScheduleIcon from '@mui/icons-material/Schedule';

function EmployeeMonthlySalary({user, isHideSideMenu}) {
    var headerShowAccess = [
        "Employee Id",
        "Employee",
        "Monthly Salary",
        "Gov't Premium Salary",
        "Allowance",
        "Is Approved?",
        "",
    ]
    var accessorShowAccess = [
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "salary",
        "governmentPremiumSalary",
        "allowance",
        "isApproved",
        "manage"
    ]
    var header = [
        "Employee Id",
        "Employee",
        "Monthly Salary",
        "Gov't Premium Salary",
        "Allowance",
        "Is Approved?",
    ]
    var accessor = [
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "salary",
        "governmentPremiumSalary",
        "allowance",
        "isApproved",
    ]
    const [currentPage, setCurrentPage] = useState(1);

    const [showSetting, setShowSetting] = useState(false);
    const settingRef = useRef(null);
    const buttonRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [employeeMonthlySalary, setEmployeeMonthlySalary] = useState([]);
    const [showUploadForm, setShowUploadForm] = useState(false);

    const [showAuthentication, setShowAuthentication] = useState(false);
    const [showAccess, setShowAccess] = useState(true);
    const [isView, setIsView] = useState(false);
    const [isViewAll, setIsViewAll] = useState(true);

    const [statusFilter, setStatusFilter] = useState("All");

    const [isSelectAll, setIsSelectAll] = useState(false);
    const [activeRowIds, setActiveRowIds] = useState([]); // Array to store active row IDs
    const [selected, setSelected] = useState([]); // Array to store active row IDs

    const triggerSelectAll = () => {
        if(employeeMonthlySalary.length <= 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Wait for the data to load.")
            return;
        }
        setIsSelectAll(true);
    }

    const unselectAll = () => {
        setSelected([]);
        setActiveRowIds([]);
        setIsSelectAll(false);
    }

    // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by employee");

    const [selectedData, setSelectedData] = useState(null);
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    const addHandleClick = (data) => {
        setShowAddForm(true);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    }
    // Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [salary, setSalary] = useState("");
    const [governmentPremiumSalary, setGovernmentPremiumSalary] = useState("");
    const [allowance, setAllowance] = useState("");
    //old
    const [oldSalary, setOldSalary] = useState("");
    const [oldGovernmentPremiumSalary, setOldGovernmentPremiumSalarySalary] = useState("");
    const [oldAllowance, setOldAllowance] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end
    
    const apiUrl =  domain + "/api/EmployeeSalary";

    const fetchDataForEmployee = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/single-data";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);

    const fetchData = useCallback(async () => {
        try{
            setLoading(true);
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            let finalData = response.data;

            if (statusFilter !== "All") {
                finalData = finalData.filter(i => 
                    statusFilter === "Approved" ? i.isApproved : !i.isApproved
                );
            }

            setEmployeeMonthlySalary(finalData); // Set the response data to the state
            setFilterData(finalData); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl, statusFilter]);

    useEffect(() => {
        fetchData();
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by employee")
                break;
            case 1:
                setSearchPlaceholder("Search by employee id")
                break;
            default:
                setSearchPlaceholder("Search by employee")
                break;
        }
    }, [filterDataIndex, fetchData]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeePersonalInformationId.toString().includes(lowercaseValue)
                );
                break;
            default:
                break;
        }

        setEmployeeMonthlySalary(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            employeePersonalInformationId: employeePersonalInformationId,
            salary: salary,
            governmentPremiumSalary: governmentPremiumSalary ? governmentPremiumSalary : 0,
            allowance: allowance
        };

        setShowAddForm(false); // Hide the add form

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            let auditInfo = [];

            auditInfo.push({
                setupArea: "Employee Monthly Salary",
                actionTaken: "add",
                field: "Salary",
                newValue: `${employeePersonalInformationFullName} ${data.salary}`,
                oldValue: ``,
                dateSaved: new Date(),
                savedById: user.id,
            });

            auditInfo.push({
                setupArea: "Employee Monthly Salary",
                actionTaken: "add",
                field: "Gov't Premium Salary",
                newValue: `${employeePersonalInformationFullName} ${data.governmentPremiumSalary}`,
                oldValue: ``,
                dateSaved: new Date(),
                savedById: user.id,
            });

            auditInfo.push({
                setupArea: "Employee Monthly Salary",
                actionTaken: "add",
                field: "Allowance",
                newValue: `${employeePersonalInformationFullName} ${data.allowance}`,
                oldValue: ``,
                dateSaved: new Date(),
                savedById: user.id,
            });
            await SetAuditTrailBulk({data: auditInfo});

            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEmployeePersonalInformationId("");
            setSalary("");
            setAllowance("");
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
        setEmployeePersonalInformationId("");
        setSalary("");
        setAllowance("");
        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            employeePersonalInformationId: employeePersonalInformationId,
            salary: salary,
            governmentPremiumSalary: governmentPremiumSalary ? governmentPremiumSalary : 0,
            allowance: allowance
        };
        setShowEditForm(false); // Hide the add form

        try {
            setLoadingRequest(true);
            await axios.put(`${apiUrl}/${selectedData.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            let auditInfo = [];

            if(data.salary !== oldSalary){
                auditInfo.push({
                    setupArea: "Employee Monthly Salary",
                    actionTaken: "update",
                    field: "Salary",
                    newValue: `${employeePersonalInformationFullName} ${data.salary}`,
                    oldValue: `${employeePersonalInformationFullName} ${oldSalary}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            if(data.governmentPremiumSalary !== oldGovernmentPremiumSalary){
                auditInfo.push({
                    setupArea: "Employee Monthly Salary",
                    actionTaken: "update",
                    field: "Gov't Premium Salary",
                    newValue: `${employeePersonalInformationFullName} ${data.governmentPremiumSalary}`,
                    oldValue: `${employeePersonalInformationFullName} ${oldGovernmentPremiumSalary}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.allowance !== oldAllowance){
                auditInfo.push({
                    setupArea: "Employee Monthly Salary",
                    actionTaken: "update",
                    field: "Allowance",
                    newValue: `${employeePersonalInformationFullName} ${data.allowance}`,
                    oldValue: `${employeePersonalInformationFullName} ${oldAllowance}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            await SetAuditTrailBulk({data: auditInfo});

            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
        setEmployeePersonalInformationId("");
        setSalary("");
        setAllowance("");
        setShowEditForm(false);
    };

    const [approvalConfirmation, setApprovalConfirmation] = useState(false);
    const openApprovalConfirmation = () => {
        setApprovalConfirmation(true);
    }
    const closeApprovalConfirmation = () => {
        setApprovalConfirmation(false);
    }

    const handleApproval = async (event) => {
        event.preventDefault();

        const data = selected.map(item => ({
            id: item.id, // Extracts 'id' from each item
            isApproved: true // Sets 'isApproved' to true
        }));

        closeApprovalConfirmation()

        try {
            setLoadingRequest(true);
            await axios.put(`${apiUrl}/approve`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            let auditInfo = [];

            selected.forEach(item => {
                if(!item.isApproved){
                    auditInfo.push({
                        setupArea: "Employee Monthly Salary",
                        actionTaken: "approve",
                        field: "Salary",
                        newValue: `${item.employeePersonalInformationFullName} approve`,
                        oldValue: `${item.employeePersonalInformationFullName} unapprove`,
                        dateSaved: new Date(),
                        savedById: user.id,
                    });
                }
            });

            await SetAuditTrailBulk({data: auditInfo});

            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };

    const handleSubmitView = async () => {
        setIsView(true);
    };
    const handleSubmitViewAll = () => {
        setIsViewAll(true);
    };
    const handleSubmitHideAll = () => {
        setIsViewAll(false);
    };
    const handleShowAccess = () => {
        // setShowAccess(true);
        setShowAuthentication(true);
    };
    const handleAuthenticationSubmit = async () =>{
        setShowAccess(true);
        setShowAuthentication(false);
    }
    const closeAuthenticationHandleClick = () => {
        setShowAuthentication(false);
    };

    const generateDownloadTemplate = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('EmployeeMonthlySalary');

        const header = [
            'EmployeeId',
            'EmployeeName',
            'Salary',
            'GovtPremiumSalary',
            'Allowance',
        ];
        const headerRow = worksheet1.addRow(header);
        worksheet1.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'employeeName', width: 30 },
            { key: 'salary', width: 30 },
            { key: 'governmentPremiumSalary', width: 30 },
            { key: 'allowance', width: 30 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const information = [
            {
                employeeId: '<EMP1234>',
                employeeName: '<DELA CRUZ, JUAN>',
                salary: '<500.00>',
                governmentPremiumSalary: '<500.00>',
                allowance: '<500.00>',
            },
        ];

        information.forEach(info => {
            worksheet1.addRow(info);
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Employee_Monthly_Salary_Template.xlsx');
    }, []);
    const generateDownloadRecords = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('EmployeeMonthlySalary');

        const header = [
            'EmployeeId',
            'EmployeeName',
            'Salary',
            'GovtPremiumSalary',
            'Allowance',
            'Is Approved?',
        ];
        const headerRow = worksheet1.addRow(header);
        worksheet1.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'employeeName', width: 30 },
            { key: 'salary', width: 30 },
            { key: 'governmentPremiumSalary', width: 30 },
            { key: 'allowance', width: 30 },
            { key: 'isApproved', width: 30 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        employeeMonthlySalary.forEach(info => {
            worksheet1.addRow([
                info.employeePersonalInformationEmployeeId,
                info.employeePersonalInformationFullName,
                info.salary?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) ?? "0.00",
                info.governmentPremiumSalary?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) ?? "0.00",
                info.allowance?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) ?? "0.00",
                info.isApproved
            ]);
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Employee_Monthly_Salary_Records.xlsx');
    }, [employeeMonthlySalary]);
    const uploadEmployeeData = async (file) => {
        setLoadingRequest(true);
        const dataEmployee = await fetchDataForEmployee();
    
        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return '';
            }
            return value;
        }

        function sanitizeValueInteger(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return 0;
            }
            return value;
        }
    
        function validateData(data) {
            const missingFields = [];
    
            data.forEach((item, index) => {
                const missing = [];

                let foundEmployee = null;

                foundEmployee = dataEmployee.find(data => (data.id).toString() === (item.employeePersonalInformationId).toString());

                if (!Number.isInteger(item.salary)) {
                    // missing.push('Daily Salary');
                    missingFields.push(`Row ${index + 1}: Invalid value - Salary`);
                }
                if (!Number.isInteger(item.governmentPremiumSalary)) {
                    // missing.push('Daily Salary');
                    missingFields.push(`Row ${index + 1}: Invalid value - Govt Premium Salary`);
                }
                if (!Number.isInteger(item.allowance)) {
                    // missing.push('Allowance');
                    missingFields.push(`Row ${index + 1}: Invalid value - Allowance`);
                }
                if (!foundEmployee) {
                    // missing.push('Section');
                    missingFields.push(`Row ${index + 1}: Invalid value - Employee Id`);
                }

                if (missing.length > 0) {
                    missingFields.push(`Row ${index + 1}: Missing fields - ${missing.join(', ')}`);
                }
            });
    
            if (missingFields.length > 0) {
                return {
                    isValid: false,
                    message: `Invalid data in the file. Please check the mandatory fields.\n${missingFields.join('\n')}`
                };
            }
    
            return { isValid: true };
        }
    
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const informations = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

            let bulkData = [];
    
            informations.forEach(info => {
                let foundEmployee = null;

                foundEmployee = dataEmployee.find(data => data.employeeId.toLowerCase() === sanitizeValue(info.EmployeeId).toString().toLowerCase());

                // i will use the locations, employments etc. here below
                bulkData.push({
                    employeePersonalInformationId: foundEmployee ?
                                sanitizeValue(foundEmployee.id)
                                :
                                0,
                    salary: info.Salary ? 
                                sanitizeValueInteger(info.Salary)
                                :
                                0,
                    governmentPremiumSalary: info.GovtPremiumSalary ? 
                                sanitizeValueInteger(info.GovtPremiumSalary)
                                :
                                0,
                    allowance: info.Allowance ? 
                                sanitizeValueInteger(info.Allowance)
                                :
                                0,
                });
            });

            // console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));
    
            // Validate the bulk data
            const validation = validateData(bulkData);
            if (!validation.isValid) {
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
                setRequestMessage(validation.message.split('\n').map((line, index) => (
                    <div key={index}>{line}</div>
                )));
                return;
            }

            const upload = async (data) => {
                const apiUrl = `${domain}/api/EmployeeSalary`;
            
                try {
                    const response = await axios.post(apiUrl, data, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    });
                    
                    console.log('Upload successful:', response.data);
                } catch (error) {
                    throw error; // Rethrow the error to handle it in the Promise.all context
                }
            }
            
            const handleBulkUpload = async () => {
                try {
                    await Promise.all(bulkData.map(data => upload(data)));
                    await SetAuditTrail({
                        setupArea: "Employee Monthly Salary", 
                        actionTaken: "insert", 
                        field: "Upload", 
                        newValue: `-`, 
                        oldValue: `-`, 
                        dateSaved: new Date(), 
                        savedById: user.id
                    });
                    await fetchData();
                    setLoadingRequest(false);
                    setRequestMessage('Upload successful');
                    setShowRequestMessage(true);
                    setIsSuccess(true);
                } catch (error) {
                    setLoadingRequest(false);
                    setShowRequestMessage(true);
                    setIsSuccess(false);
                    console.error('Error:', error);
                    const errorMessage = error.response?.data?.message || 'An error occurred';
                    setRequestMessage(errorMessage);
                }
            }
            
            handleBulkUpload();
        };
    
        reader.readAsArrayBuffer(file);
    };
    function handleFileUpload(files) {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        const file = files[0];
        uploadEmployeeData(file);
    }

    const fetchDataCompany = useCallback(async () => {
        const apiUrl =  domain + "/api/Company";
        try{
            const response = await axios.get(apiUrl +`/${1}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return null;
        }
    }, []);

    const downloadAuditTrail = async () => {
        setLoadingRequest(true);

        const auditTrailData = await GetAuditTrail();
        const company = await fetchDataCompany();
        // Create a new jsPDF instance
        const _doc = new jsPDF("landscape");

        const drawLine = (doc, lineX, lineY) => {
            const startX = lineX;
            const endX = doc.internal.pageSize.getWidth() - 10; // Width of page minus some margin
            const startY = lineY;
            doc.line(startX, startY, endX, startY);
        };
        const title = (doc, title, titleX, titleY) =>{
            doc.setFont("helvetica", "bold");
            doc.setFontSize(14);
            // doc.setTextColor("#668fca");
            doc.setLineWidth(0.5);
            doc.text(title, titleX, titleY);
        }
        const header = (doc, title, titleX, titleY) =>{
            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            // doc.setTextColor("#668fca");
            doc.setLineWidth(0.5);
            doc.text(title, titleX, titleY);
        }
        const info = (doc, label, labelX, labelY, maxWidth) => {
            doc.setFont("helvetica", "normal");
            doc.setFontSize(9);
        
            // Ensure label is a string and not null/undefined
            const text = label ? String(label) : "-"; // Use "-" as a fallback for empty values
        
            // Use the `maxWidth` argument to limit the text width
            doc.text(text, labelX, labelY, { maxWidth: maxWidth });
        };
        
        function formatDate(dateStr) {
            const date = new Date(dateStr);
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            const formattedDate = date.toLocaleDateString("en-US", options);
            return formattedDate;
        }
        
        // Add the image to the PDF
        const imgData = `data:image/png;base64,${company.logo}`;
        _doc.addImage(imgData, 'PNG', 110, 5, 70, 30);

        
        title(_doc, `Audit Trail Report - Employee Setup`, 102.5, 40);

        drawLine(_doc, 10, 55);
        header(_doc, `Setup Area`, 11, 60);
        header(_doc, `Action Taken`, 50, 60);
        header(_doc, `Field`, 85, 60);
        header(_doc, `New Value`, 120, 60);
        header(_doc, `Old Value `, 160, 60);
        header(_doc, `Date Saved`, 200, 60);
        header(_doc, `Saved By`, 240, 60);
        drawLine(_doc, 10, 62.5);

        // Add data here
        let y = 67.5; // Starting Y position for data
        const pageHeight = _doc.internal.pageSize.getHeight();
        const threshold = pageHeight - 20; 

        auditTrailData.forEach((audit, index) => {
            if (y > threshold) {
                _doc.addPage(); // Add new page
                y = 20;
            }

            let additionalY = 5; // Start with the default increment
            let lineHeight = 5;  // Line height for each new line

            const { 
                setupArea, 
                actionTaken,
                field,
                newValue,
                oldValue,
                dateSaved,
                savedByEmployeePersonalInformationFullName,
            } = audit;

            info(_doc, setupArea, 12, y, 35);
            info(_doc, actionTaken, 50, y, 35);
            info(_doc, field, 85, y, 35);
            info(_doc, newValue, 120, y, 35);
            info(_doc, oldValue, 160, y, 35);
            info(_doc, formatDate(dateSaved), 200, y, 35);
            info(_doc, savedByEmployeePersonalInformationFullName, 240, y, 50);

            const getTotalLines = (doc, text, maxWidth) => {
                const lines = doc.splitTextToSize(text, maxWidth); // Split the text into lines based on maxWidth
                return lines.length;
            };

            const setupAreaLines = getTotalLines(_doc, setupArea, 35);
            const actionTakenLines = getTotalLines(_doc, actionTaken, 35);
            const fieldLines = getTotalLines(_doc, field, 35);
            const newValueLines = getTotalLines(_doc, newValue, 35);
            const oldValueLines = getTotalLines(_doc, oldValue, 35);
            const dateSavedLines = getTotalLines(_doc, formatDate(dateSaved), 35);
            const savedByLines = getTotalLines(_doc, savedByEmployeePersonalInformationFullName, 50);

            const maxLines = Math.max(
                setupAreaLines, 
                actionTakenLines, 
                fieldLines, 
                newValueLines, 
                oldValueLines, 
                dateSavedLines, 
                savedByLines
            );

            // Adjust `additionalY` based on the number of lines (if more than 1 line, add additional Y)
            if (maxLines > 1) {
                additionalY += (maxLines - 1) * lineHeight; // Add 5 for each additional line beyond the first
            }

            // Increment Y position for the next row
            y += additionalY;
        });
        
        setLoadingRequest(false);

        // Save the PDF
        _doc.save(`Unapproved_Salaries.pdf`);
    };

    const handleSetting = () =>{
        setShowSetting(!showSetting);
    };

    useEffect(() => {
        var settingIcon = document.getElementById("setting-icon");

        if(showSetting){
            //change the down icon to up
            settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`); // Up Arrow.Path d attribute    
        } else {
            //change the up icon to down
            settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`); // Down Arrow.Path d attribute
        }

        const handleClickOutside = (event) => {
            if (settingRef.current && !settingRef.current.contains(event.target)) {
                if(buttonRef.current && !buttonRef.current.contains(event.target)){
                    setShowSetting(false);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };


    }, [showSetting]);

    const editHandleClick = (data) => {
        setSelectedData(data);
        setShowEditForm(true);
        setEmployeePersonalInformationFullName(data.employeePersonalInformationFullName);
        setEmployeePersonalInformationId(data.employeePersonalInformationId);
        setSalary(data.salary);
        setGovernmentPremiumSalary(data.governmentPremiumSalary);
        setAllowance(data.allowance);
        setOldSalary(data.salary);
        setOldGovernmentPremiumSalarySalary(data.governmentPremiumSalary);
        setOldAllowance(data.allowance);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };
    const openUploadFormHandleClick  = () =>{
        setShowUploadForm(true);
    }
    const closeUploadFormHandleClick = () =>{
        setShowUploadForm(false);
    }

    const isUserApprover = (user?.username === "admin" || user?.username === "hrmanager");

    const [historyData, setHistoryData] = useState([]);
    const [showHistoryForm, setShowHistoryForm] = useState(false);
    const openHistoryForm = () => {
        setShowHistoryForm(true)
    }
    const closeHistoryForm = () => {
        setShowHistoryForm(false)
    }

    const fetchDataSalaryHistory = useCallback(async (_data) => {
        const apiUrl =  domain + "/api/EmployeeSalary";
        const _dataToPass = {
            employeePersonalInformationId: _data?.employeePersonalInformationId
        }

        try{
            const response = await axios.post(`${apiUrl}/get-history`, _dataToPass, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);

    const viewHistoryHandleClick = async (_data) => {
        setLoading(true)
        const _historyData = await fetchDataSalaryHistory(_data)
        setHistoryData(_historyData)

        openHistoryForm()

        setLoading(false)
    }

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Salary Module >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Employee Monthly Salary"}</span>
                            </div>
                            <div className='row' style={{justifyContent: "space-between", alignItems: "center"}}>
                                <h3>Employee Monthly Salary</h3>
                                <div style={{width:"30%",textAlign:"right", display: showAccess ? "block" : "none"}}>
                                    <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                                        <SettingsIcon/>
                                        <KeyboardArrowDownIcon id="setting-icon"/>
                                    </button>
                                    <div ref={settingRef}>
                                        {showSetting && 
                                            <SettingInit
                                            generateDownloadTemplate={generateDownloadTemplate}
                                            openUploadFormHandleClick={openUploadFormHandleClick}
                                            downloadAuditTrail={downloadAuditTrail}
                                            isUserApprover={isUserApprover}
                                            />}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="employeesTab-body">
                            {Filter(setFilterDataIndex)}
                            <div style={{marginTop: '5px'}}>
                                <StatusFilter statusFilter={statusFilter} setStatusFilter={setStatusFilter}/>
                            </div>
                            <div className="body-top row">
                                <div className="body-top-search">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                    "mainte-search row", 
                                                                    "mainte-search-icon", 
                                                                    "mainte-search-input", 
                                                                    (e)=>handleFilter(e.target.value), 
                                                                    searchPlaceholder, 
                                                                    SearchIcon)}
                                </div>
                                <div className="body-top-btn row" style={{justifyContent: "end"}}>
                                    {showAccess && 
                                        <>
                                            {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                            
                                            {isUserApprover && (
                                                <>
                                                    {CreateButton("", "approve row", openApprovalConfirmation, "APPROVE", DoneIcon)}
                                                    {!isSelectAll ?  
                                                        CreateButton("", "approve row", triggerSelectAll, "SELECT ALL", ChecklistIcon) : 
                                                        CreateButton("", "approve row", unselectAll, "UNSELECT ALL", ChecklistIcon)
                                                    }
                                                </>
                                            )}

                                            {CreateButton("", "view-all row", generateDownloadRecords, "EXTRACT", DownloadIcon)}
                                        </>
                                    }
                                    <div style={{display: "none"}}>
                                    {showAccess ?
                                        isViewAll ?
                                            CreateButton("", "hide row", ()=>handleSubmitHideAll(), "HIDE ALL", VisibilityOffIcon)
                                            :
                                            <div style={{display: "none"}}>
                                                {CreateButton("", "showAccess row", ()=>handleSubmitViewAll(), "VIEW ALL", RemoveRedEyeIcon)}
                                            </div>
                                        :
                                        CreateButton("", "showAccess row", ()=>handleShowAccess(), "SHOW ACCESS", LockOpenIcon)
                                    }
                                    </div>
                                </div>
                            </div>
                            <div className="employeesTab-table container">
                                <CreateTable
                                    dataList={employeeMonthlySalary}
                                    dataHeader={showAccess ? headerShowAccess : header}
                                    dataAccessor={showAccess ? accessorShowAccess : accessor}
                                    editHandleClick={editHandleClick}
                                    viewRequest={handleSubmitView}
                                    viewHistoryHandleClick={viewHistoryHandleClick}
                                    isViewAll={isViewAll}
                                    isView={isView}
                                    setIsView={setIsView}
                                    showAccess={showAccess}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}

                                    selected={selected}
                                    setSelected={setSelected}
                                    isSelectAll={isSelectAll}
                                    setIsSelectAll={setIsSelectAll}
                                    activeRowIds={activeRowIds}
                                    setActiveRowIds={setActiveRowIds}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    employeePersonalInformationId={employeePersonalInformationId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    salary={salary}
                    governmentPremiumSalary={governmentPremiumSalary}
                    setGovernmentPremiumSalary={setGovernmentPremiumSalary}
                    allowance={allowance}
                    setSalary={setSalary}
                    setAllowance={setAllowance}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    setShowEmployeeForm={setShowEmployeeForm}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    employeePersonalInformationId={employeePersonalInformationId}
                    salary={salary}
                    governmentPremiumSalary={governmentPremiumSalary}
                    setGovernmentPremiumSalary={setGovernmentPremiumSalary}
                    allowance={allowance}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    setSalary={setSalary}
                    setAllowance={setAllowance}
                    handleSubmit={handleUpdate}
            >
            </EditForm>
            <UploadForm  isOpen={showUploadForm} 
                    onClose={closeUploadFormHandleClick}
                    handleFileUpload={handleFileUpload}
            >
            </UploadForm>
            <Authentication isOpen={showAuthentication} 
                    onClose={closeAuthenticationHandleClick}
                    user={user}
                    handleSubmit={handleAuthenticationSubmit}
            >
            </Authentication>
            <ApprovalForm  isOpen={approvalConfirmation} 
                    onClose={closeApprovalConfirmation}
                    handleApprove={handleApproval}
            >
            </ApprovalForm>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
            >
            </EmployeeSelectForm>
            <ViewHistoryForm  isOpen={showHistoryForm} 
                    onClose={closeHistoryForm}
                    historyData={historyData}
            />
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}
function AddForm({isOpen, 
    onClose, 
    employeePersonalInformationId,
    employeePersonalInformationFullName,
    salary,
    governmentPremiumSalary,
    setGovernmentPremiumSalary,
    allowance,
    setEmployeePersonalInformationId,
    setEmployeePersonalInformationFullName,
    setSalary, 
    setAllowance, 
    setShowEmployeeForm,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (!employeePersonalInformationId || !salary || !allowance) {
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setEmployeePersonalInformationId("");
        setEmployeePersonalInformationFullName("");
        setSalary("");
        setGovernmentPremiumSalary("");
        setAllowance("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Monthly Salary</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                    <button className="select row"
                                            onClick={()=>setShowEmployeeForm(true)}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                                {/* {EmployeeIdSelect(employeePersonalInformationId, setEmployeePersonalInformationId)} */}
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Salary</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="salary"
                                placeholder="Salary"
                                value={salary}
                                onChange={(e) => setSalary(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !salary && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Government Premium Salary</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="governmentPremiumSalary"
                                placeholder="Government Premium Salary"
                                value={governmentPremiumSalary}
                                onChange={(e) => setGovernmentPremiumSalary(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Allowance</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="allowance"
                                placeholder="Allowance"
                                value={allowance}
                                onChange={(e) => setAllowance(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !allowance && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose, 
    employeePersonalInformationFullName,
    employeePersonalInformationId,
    salary,
    governmentPremiumSalary,
    setGovernmentPremiumSalary,
    allowance,
    setEmployeePersonalInformationId,
    setSalary, 
    setAllowance, 
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (employeePersonalInformationId === ""
            || salary  === ""
            || allowance === ""
        ) {
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setEmployeePersonalInformationId("");
        setSalary("");
        setGovernmentPremiumSalary("");
        setAllowance("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Monthly Salary</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee Id</div>
                            <div className="info-item-input">
                                <input
                                readOnly
                                id="employeePersonalInformationId"
                                placeholder="Employee Id"
                                value={`${employeePersonalInformationFullName}`}
                                onChange={(e) => setEmployeePersonalInformationId(e.target.value)}
                                style={{cursor:"not-allowed"}}
                                />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Salary</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="salary"
                                placeholder="Salary"
                                value={salary}
                                onChange={(e) => setSalary(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: salary === "" && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Government Premium Salary</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="governmentPremiumSalary"
                                placeholder="Government Premium Salary"
                                value={governmentPremiumSalary}
                                onChange={(e) => setGovernmentPremiumSalary(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Allowance</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="allowance"
                                placeholder="Allowance"
                                value={allowance}
                                onChange={(e) => setAllowance(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: allowance === "" && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ApprovalForm({isOpen, 
    onClose, 
    handleApprove}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Approve Confirmation!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to approve selected employee/s?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleApprove}
                            style={{marginRight:"5px"}}>
                                Approve
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function StatusFilter({statusFilter, setStatusFilter}){
    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Status</span>
            <select id="" className="filterSelect" value={statusFilter} onChange={(e)=>setStatusFilter(e.target.value)}>
                <option value="All">All</option>
                <option value="Approved">Approved</option>
                <option value="Unpproved">Unpproved</option>
            </select>
        </div>
    );
};
function Authentication({
    isOpen, 
    onClose,
    user,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    // const [loading, setLoading] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = async (e) =>{
        if(!username 
            || !password
        ){
            setErrorState(true);
            return;
        }

        if(username !== "admin" || password !== "qkEcJETL"){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Invalid username or password");
            return;
        }

        /* const isAuthorize = await checkUser(e);

        if(!isAuthorize){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Invalid username or password");
            return;
        } */

        handleSubmit();
        setErrorState(false);
    };

    /* const checkUser = async (event) => {
        event.preventDefault();

        const data = {
            userName: username,
            password: password
        };

        const apiUrlFetch = domain + "/api/Authentication/login";

        try {
            setLoading(true);
            const response = await axios.post(apiUrlFetch, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if(response.data.employeePersonalInformationId === user.employeePersonalInformationId){
                return true;
            } else {
                return false;
            }
        } catch (error) {
            setLoading(false);
            return false;
        } finally {
            setLoading(false);
        }
    }; */

    const handleClose = () => {
        onClose();
        setUsername("")
        setPassword("")
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Authentication</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Username</div>
                            <div className="info-item-input">
                                <input
                                placeholder="Username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !username && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Password</div>
                            <div className="info-item-input">
                                <input
                                type='password'
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !password && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                ENTER
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {/* {loading ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            } */}
        </>
    );
}
function SettingInit({
    generateDownloadTemplate,
    openUploadFormHandleClick,
    downloadAuditTrail,
    isUserApprover
}){

    return(
        <div id='payroll-setting' className="payroll-setting column">
            <div className="payroll-setting-item row" onClick={()=>generateDownloadTemplate(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Template
            </div>
            <div className="payroll-setting-item row"onClick={()=>openUploadFormHandleClick()}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload Monthly Salary
            </div>
            {isUserApprover &&
                <div className="payroll-setting-item row"onClick={()=>downloadAuditTrail()}>
                    <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                    Audit Trail For Unapproved Salaries
                </div>
            }
        </div>
    )
}
function UploadForm({isOpen, 
    onClose,
    handleFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
    };

    const [files, setFiles] = useState([]);

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };


    const submit = (e) =>{
        handleFileUpload(files);
        handleClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload Monthly Salary"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>
                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                            <button id="add-family" 
                                className="save row"
                                onClick={(e)=>submit(e)}
                                style={{marginRight:"5px"}}>
                                    UPLOAD
                            </button>
                            <button id="add-family" 
                                className="cancel row"
                                onClick={()=>handleClose()}>
                                    CANCEL
                            </button>
                        </div>)
                    }
                </div>
            )}
            </div>
        </>
    );
}
export function CreateTable({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [], 
    editHandleClick, 
    viewRequest, 
    isViewAll, 
    isView,
    setIsView,
    deleteHandleClick,
    viewHistoryHandleClick,
    showAccess,

    selected, setSelected, isSelectAll, setIsSelectAll, activeRowIds, setActiveRowIds,

    currentPage, setCurrentPage
}) {
    // const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [viewCell, setViewCell] = useState(null);

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const handleViewRequest = (cellKey) => {
        setViewCell(cellKey);
        viewRequest(false); // Or whatever logic you need to handle the view request
        setIsView(true);
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    useEffect(() => {
        if (isSelectAll) {
            const newActiveRowIds = rows.map(item => item.original.id);
            const newActiveRowOriginal = rows.map(item => item.original);
    
            // Only update state if values are actually different
            setActiveRowIds(prevIds => {
                if (JSON.stringify(prevIds) !== JSON.stringify(newActiveRowIds)) {
                    return newActiveRowIds;
                }
                return prevIds;
            });
    
            setSelected(prevSelected => {
                if (JSON.stringify(prevSelected) !== JSON.stringify(newActiveRowOriginal)) {
                    return newActiveRowOriginal;
                }
                return prevSelected;
            });
        }
    }, [isSelectAll, rows, setActiveRowIds, setSelected]);    
    
    const handleRowClick = (rowData) => {
        setSelected(prevSelected => {
            const isAlreadySelected = prevSelected.some(item => item.id === rowData.id);
            return isAlreadySelected
                ? prevSelected.filter(item => item.id !== rowData.id)  // Remove rowData if already selected
                : [...prevSelected, rowData];                         // Add rowData if not selected
        });
        setActiveRowIds(prevIds => 
            prevIds.includes(rowData.id) 
            ? prevIds.filter(id => id !== rowData.id)  // Remove the row ID if it is already active
            : [...prevIds, rowData.id]                 // Add the new row ID if it is not already active
        );
    };

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                            className={activeRowIds?.includes(row.original.id) ? 'active' : ''}
                            >
                                {row.cells.map((cell) => (
                                    <SetInfo header={cell.render("Cell").props.column.Header}
                                            _cell={cell}
                                            editHandleClick={editHandleClick}
                                            viewRequest={() => handleViewRequest(cell.getCellProps().key)}
                                            isViewAll={isViewAll}
                                            isView={viewCell === cell.getCellProps().key}
                                            setIsView={setIsView}
                                            showAccess={showAccess}
                                            viewHistoryHandleClick={viewHistoryHandleClick}
                                            />
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfo({header, 
    _cell, 
    editHandleClick, 
    viewRequest, 
    isViewAll, 
    isView,
    setIsView,
    showAccess,
    deleteHandleClick,
    viewHistoryHandleClick
}) {
    const data = _cell.render("Cell").props.row.original;

    const [isExpandedCell, setIsExpandedCell] = useState(null);

    const handleCellClick = () => {
        if (isExpandedCell === _cell.getCellProps().key) {
            setIsExpandedCell(null); // Collapse the current cell if clicked again
        } else {
            setIsExpandedCell(_cell.getCellProps().key); // Expand the clicked cell
            viewRequest(_cell.getCellProps().key); // Pass the cell key to handle the view request
        }
    };

    //Double type data
    if (header === "Monthly Salary" || header === "Allowance"  || header === "Gov't Premium Salary") {
        const value = _cell.render("Cell").props.value;
        // Check if value is a number
        const isNumber = typeof value === 'number';
    
        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if (!isNumber) {
            return (
            <td {..._cell.getCellProps()}>
                {_cell.render("Cell")}
            </td>
            );
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        if (isViewAll) {
            return (
                <td>
                    <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                        {formattedNumber}
                        {/* <Tooltip text="Hide">
                            <div className='history' style={{padding:"0 5px", marginRight:"5px"}} onClick={handleCellClick }><VisibilityOffIcon/></div>
                        </Tooltip> */}
                    </div>
                </td>
            );
        }

        if (isExpandedCell === _cell.getCellProps().key) {
            return (
                <td>
                    <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                        {formattedNumber}
                        <Tooltip text="Hide">
                            <div className='history' style={{padding:"0 5px", marginRight:"5px"}} onClick={handleCellClick }><VisibilityOffIcon/></div>
                        </Tooltip>
                    </div>
                </td>
            );
        }

        return (
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    *****
                    {showAccess ?
                        <Tooltip text="View">
                            <div className='history' style={{padding:"0 5px", marginRight:"5px"}} onClick={handleCellClick }><RemoveRedEyeIcon/></div>
                        </Tooltip>
                        :
                        <></>
                    }
                </div>
            </td>
        );
    }

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    <Tooltip text="History">
                        <div style={{padding:"0 5px"}} onClick={()=>viewHistoryHandleClick(data)}><ScheduleIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if(header === "Is Approved?"){
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={data.isApproved}
                    disabled={true}
                />
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '70%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const monthlyClassification = 1;

    const fetchData = async () => {
        const apiUrl =  domain + `/api/Employee/basic-info/all/active/classification/${monthlyClassification}`;

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
const GetAuditTrail = async () => {
    const apiUrl =  domain + "/api/AuditTrail/unapproved-salaries";

    try {
        const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        return [];
    }
}
function ViewHistoryForm({ isOpen, onClose, historyData }) {
    var header = [
        "Action Type",
        "Salary",
        "Government Premium Salary",
        "Allowance",
        "Is Approved?",
    ];
    var accessor = [
        "actionType",
        "salary",
        "governmentPremiumSalary",
        "allowance",
        "isApproved",
    ];

    const [currentPage, setCurrentPage] = useState(1)

    const handleClose = () => {
        onClose();
        setCurrentPage(1)
    };

    return (
        <>
        <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
            {isOpen && (
            <div className="modal">
                <div className="popUp-header row">
                <div className="popUp-title">
                    <h3 style={{ color: "#668fca" }}>History</h3>
                </div>
                <div className="popUp-close">
                    <CloseIcon onClick={() => handleClose()} />
                </div>
                </div>
                <div className="popUp-body loan-history-table user-template-body">
                <div
                    className="users-table container"
                    style={{ overflow: "unset" }}
                >
                    <CreateTableHistory
                        dataList={historyData || []}
                        dataHeader={header}
                        dataAccessor={accessor}
                        currentPage={currentPage} 
                        setCurrentPage={setCurrentPage}
                    />
                </div>
                </div>
                <div
                className="buttons row"
                style={{
                    justifyContent: "center",
                    padding: "40px 40px 20px 40px",
                }}
                ></div>
            </div>
            )}
        </div>
        </>
    );
}
export function CreateTableHistory({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  editHandleClick,
  deleteHandleClick,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: dataList });

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr key={row.original.id} {...row.getRowProps()}>
                {row.cells.map((cell) =>
                  SetInfoHistory(
                    cell.render("Cell").props.column.Header,
                    cell,
                    editHandleClick,
                    deleteHandleClick
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "26px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </>
      ) : (
        <></>
      )}
    </>
  );
}
function SetInfoHistory(header, _cell, editHandleClick, deleteHandleClick) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "") {
    return (
      <td>
        <div
          className="row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <Tooltip text="Update">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => editHandleClick(data)}
            >
              <ModeEditIcon />
            </div>
          </Tooltip>
          {deleteHandleClick ? (
            <Tooltip text="Delete">
              <div
                style={{ padding: "0 5px" }}
                onClick={() => deleteHandleClick(data)}
              >
                <DeleteForeverIcon />
              </div>
            </Tooltip>
          ) : (
            <></>
          )}
        </div>
      </td>
    );
  }

  if (header === "Uploaded Image") {
    if (data.content) {
      const imageSrc = "data:image/jpeg;base64," + data.content;

      return (
        <td>
          <img
            className=""
            src={imageSrc}
            alt=""
            style={{ width: "250px", height: "auto" }}
          />
        </td>
      );
    }
    return (
      <td>
        <img className="" src="" alt="" />
      </td>
    );
  }

  if (header === "Reference No.") {
    const formattedNumber = value.toString().padStart(6, "0");

    if (data.requestTypeId === 1) {
      return <td>LV-{formattedNumber}</td>;
    } else if (data.requestTypeId === 2) {
      return <td>CS-{formattedNumber}</td>;
    } else if (data.requestTypeId === 3) {
      return <td>OT-{formattedNumber}</td>;
    } else if (data.requestTypeId === 4) {
      return <td>CH-{formattedNumber}</td>;
    } else if (data.requestTypeId === 5) {
      return <td>OS-{formattedNumber}</td>;
    } else if (data.requestTypeId === 6) {
      return <td>OB-{formattedNumber}</td>;
    }
  }

  if (header === "Is Approved?") {
    return <td>{data.isApproved ? "Approved" : "Pending"}</td>;
  }

  if (header === "Has Allowance" || header === "Is Above 2 Hours") {
    return <td>{value.toString()}</td>;
  }

  if (
    header === "Date" ||
    header === "Date From" ||
    header === "Date To" ||
    header === "Date Processed" ||
    header === "Request Date" ||
    header === "Date Requested" ||
    header === "Created Date"
  ) {
    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return <td>-</td>;
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  //Double type data
  if (
    header === "Over Percentage" ||
    header === "Deduction" ||
    header === "Salary" ||
    header === "Employee" ||
    header === "Employer" ||
    header === "Range From" ||
    header === "Range To" ||
    header === "Monthly Salary" ||
    header === "SSS ER" ||
    header === "SSS EE" ||
    header === "SSS Total" ||
    header === "ECER" ||
    header === "Total Contribution ER" ||
    header === "Total Contribution EE" ||
    header === "Total Contribution Total" ||
    header === "SE Total Contribution" ||
    header === "Salary Range From" ||
    header === "Salary Range To" ||
    header === "Total Monthly Premium" ||
    header === "Percentage" ||
    header === "Amount" ||
    header === "Total Loan" ||
    header === "Total Balance" ||
    header === "Default Deduction" ||
    header === "Allowance" ||
    header === "Daily Salary" ||
    header === "Allowance" ||
    header === "Total Basic" ||
    header === "Rate" ||
    header === "Hours OT Regular" ||
    header === "Total OT Regular" ||
    header === "Hours OT Exceeded" ||
    header === "Total OT Exceeded" ||
    header === "Hours OT Restday" ||
    header === "Total OT Restday" ||
    header === "Hours Holiday Special" ||
    header === "Total Holiday Special" ||
    header === "Hours Holiday Regular" ||
    header === "Total Holiday Regular" ||
    header === "Hours Restday Holiday Special" ||
    header === "Total Restday Holiday Special" ||
    header === "Hours Restday Holiday Regular" ||
    header === "Total Restday Holiday Regular" ||
    header === "Additions" ||
    header === "SSS" ||
    header === "Pagibig" ||
    header === "Philhealth" ||
    header === "SSS Loan" ||
    header === "SSS Calamity Loan" ||
    header === "Pagibig Loan" ||
    header === "Pagibig Calamity Loan" ||
    header === "Tax" ||
    header === "Deductions" ||
    header === "Adjustments" ||
    header === "Total Net Pay" ||
    header === "Days Absent" ||
    header === "Absent/s" ||
    header === "Days Leave" ||
    header === "Leave/s" ||
    header === "Hours Exceeded" ||
    header === "Total Exceeded" ||
    header === "Hours Undertime" ||
    header === "Undertime" ||
    header === "Hours Late" ||
    header === "Late" ||
    header === "Night Diff" ||
    header === "OT Regular" ||
    header === "OT Restday" ||
    header === "Holiday Special" ||
    header === "Holiday Regular" ||
    header === "Restday Holiday Special" ||
    header === "Restday Holiday Regular" ||
    header === "Total Absents" ||
    header === "Total Late" ||
    header === "Total Undertime" ||
    header === "Total Leaves" ||
    header === "Total Night Diff" ||
    header === "Total Exceed" ||
    header === "Government Premium Salary" ||
    header === "Exceed"
  ) {
    const value = _cell.render("Cell").props.value;

    // Check if value is a number
    const isNumber = typeof value === "number";

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    if (!isNumber) {
      return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    return <td>{formattedNumber}</td>;
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
export default EmployeeMonthlySalary
